export default __webpack_public_path__ + "static/media/genesis-node.62232d77.png";